/**
 * Brand Color System for AutoTransporter
 * Primary Brand: Vibrant Teal — #0FB9B1 (Trust, Innovation, Movement)
 * Secondary: Navy Blue — #0A2540 (Strength, Professionalism)
 * Deep Charcoal — #1B1E23 (Tech, Depth)
 */

//  backgroundColor: "#0b1120", borderTopColor: "#1e293b",

import { Platform } from 'react-native';

// Brand Colors
export const BrandColors = {
  primary: "#0FB9B1", // Vibrant Teal
  secondary: "#0A2540", // Navy Blue
  charcoal: "#1B1E23", // Deep Charcoal
  white: "#FFFFFF",
  offWhite: "#F9FAFB",
  lightGray: "#E5E7EB",
  mediumGray: "#9CA3AF",
  darkGray: "#4B5563",
  backgroundGray: "#F3F4F6",
  primaryLight: "#E0F7F6",
  success: "#23D18B",
  warning: "#FFB020",
  error: "#EF4444",
  errorLight: "#FECACA",
  info: "#0284C7",
  backgroundInput: "#111827",
  card: "#D8E5FF" + "10",
} as const;

const tintColorLight = BrandColors.primary; // Vibrant Teal
const tintColorDark = BrandColors.white;

export const Colors = {
  light: {
    text: BrandColors.charcoal, // Deep Charcoal for text
    background: BrandColors.white,
    tint: tintColorLight,
    icon: BrandColors.mediumGray,
    tabIconDefault: BrandColors.mediumGray,
    tabIconSelected: tintColorLight,
    // Additional semantic colors
    primary: BrandColors.primary,
    secondary: BrandColors.secondary,
    success: BrandColors.success,
    warning: BrandColors.warning,
    error: BrandColors.error,
    info: BrandColors.info,
    border: BrandColors.lightGray,
    card: BrandColors.offWhite,
    ripple: "rgba(255, 255, 255, 0.6)",
  },
  dark: {
    text: BrandColors.offWhite,
    background: "#10192A", // Deep Charcoal for dark background  "#0b1120"
    tint: tintColorDark,
    icon: BrandColors.mediumGray,
    tabIconDefault: BrandColors.mediumGray,
    tabIconSelected: tintColorDark,
    // Additional semantic colors
    primary: BrandColors.primary,
    secondary: BrandColors.secondary,
    success: BrandColors.success,
    warning: BrandColors.warning,
    error: BrandColors.error,
    info: BrandColors.info,
    border: BrandColors.darkGray,
    card: BrandColors.card,
    ripple: "rgba(255, 255, 255, 0.3)",
  },
};

export const Fonts = Platform.select({
  ios: {
    /** iOS `UIFontDescriptorSystemDesignDefault` */
    sans: 'system-ui',
    /** iOS `UIFontDescriptorSystemDesignSerif` */
    serif: 'ui-serif',
    /** iOS `UIFontDescriptorSystemDesignRounded` */
    rounded: 'ui-rounded',
    /** iOS `UIFontDescriptorSystemDesignMonospaced` */
    mono: 'ui-monospace',
  },
  default: {
    sans: 'normal',
    serif: 'serif',
    rounded: 'normal',
    mono: 'monospace',
  },
  web: {
    sans: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    serif: "Georgia, 'Times New Roman', serif",
    rounded: "'SF Pro Rounded', 'Hiragino Maru Gothic ProN', Meiryo, 'MS PGothic', sans-serif",
    mono: "SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
  },
});
